import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import * as SiteFeedbackAPI from '../../services/SiteFeedbackServices';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { FaCopy, FaUserSlash, FaUserPlus, FaMinus} from 'react-icons/fa'; 

const SendSiteFeedbackAdmin = () => {
    const { userId, user } = useContext(AuthContext);

    const [text, setText] = useState('');
    const [messageText, setMessageText] = useState('');
    const [allFeedback, setAllFeedback] = useState([]);

    const handleSubmit = async () => {
        await SiteFeedbackAPI.createFeedback({ sender: userId, text, sitewide: true });
    }

    const getAllFeedback = async () => {
        try {
            const feedbacks = await SiteFeedbackAPI.getAllSiteFeedback();
            setAllFeedback(feedbacks);
        } catch (error) {
            console.error("Error fetching site feedback:", error);
        }
    }

    const addMessage = async (feedbackId) => {
        try {
            await SiteFeedbackAPI.addMessage(feedbackId, { sender: userId, text: messageText });
            getAllFeedback();
        } catch (error) {
            console.error("Error fetching site feedback:", error);
        }
    }

    

    return (
        <div>
            <div>Site Feedback ADMIN</div>
            <input
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value)}
            />
            <button onClick = {() => handleSubmit()}>Submit</button>


            <div>
                Get All Feedback
                <button onClick = {() => getAllFeedback()}>Get</button>
                {allFeedback.map(feedback => (
                    <div>
                        <button onClick={() => addMessage(feedback._id)}>Add message</button>
                        <input
                type="text"
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
            />
                        <span>{feedback.sender.username}</span>
                        {feedback.messages.map(message => (
                            <span>      {message.sender.username} {message.text}</span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )
};

export default SendSiteFeedbackAdmin
